export default __webpack_public_path__ + "static/media/decada-0090-0010-min.e12cba47.jpg";